import { render } from "./Auth.vue?vue&type=template&id=f5a32986&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=f5a32986&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5a32986"

export default script